import { combineReducers } from 'redux';

import { createTestsReducer } from './reducers/tests';
import { createErrorsReducer } from './reducers/errors';
import { createBuildsReducer } from './reducers/builds';

export const createTrendsReducer = (types) => {
  const { reducer: tests, initialState: testsStore } = createTestsReducer(types);
  const { reducer: errors, initialState: errorsStore } = createErrorsReducer(types);
  const { reducer: builds, initialState: buildsStore } = createBuildsReducer(types);

  const reducer = combineReducers({
    tests,
    errors,
    builds,
  });
  const initialState = {
    tests: testsStore,
    errors: errorsStore,
    builds: buildsStore,
  };
  return { reducer, initialState };
};
